import { type Repub } from '@cx-modules/types';

import { excludedRegionsFromHeaderFooterV2 } from '~/constants/nav-footer-v2';

export function shouldUseHeaderFooterV2(repub: Repub): boolean {
	return !excludedRegionsFromHeaderFooterV2.has(repub);
}
